import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type CreateUpdateImportResponse = {
   externalTrainingModuleImportId: number;
};

export async function createExternalTrainingModuleUpdateImport(
   external_training_moduleid: number,
   type: 'URL' | 'FILE_UPLOAD',
   sourceName: string,
   common: CommonRequestOptions = {}
): Promise<CreateUpdateImportResponse> {
   return makeRequest('post', `/external-training-modules/imports/${external_training_moduleid}`, {
      ...common,
      body: {
         type,
         sourceName,
      },
   });
}
